var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 32,
      height: 32,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4B4B4B;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.048,151.261c-7.94-14.22-17.942-24.839-27.118-33.189c0.927-3.978,1.475-8.488,1.475-13.462 c0-9.779-2.086-21.31-7.731-33.135c-8.442-17.748-25.002-35.9-53.418-49.254C352.826,8.828,312.624,0.008,256.001,0 c-75.468,0.008-121.879,15.687-149.862,36.981C92.182,47.616,82.96,59.665,77.321,71.475C71.683,83.3,69.59,94.831,69.59,104.61 c0,4.981,0.556,9.492,1.475,13.47c-9.168,8.349-19.17,18.969-27.102,33.181c-8.705,17.301-6.218,38.124,6.318,52.907l11.161,13.139 l122.73-104.186l-11.146-13.146c-12.535-14.76-32.678-20.607-51.177-14.829c-14.899,5.368-26.77,13.231-36.37,20.746 c-0.008-0.448-0.07-0.826-0.07-1.282c0-7.539,1.622-16.753,6.186-26.315c6.874-14.312,20.275-29.651,45.895-41.769 c25.596-12.08,63.511-20.715,118.512-20.708c73.368-0.016,116.203,15.347,140.262,33.745c12.065,9.207,19.564,19.178,24.137,28.732 c4.572,9.562,6.194,18.776,6.186,26.315c0,0.456-0.062,0.834-0.07,1.282c-9.601-7.515-21.464-15.378-36.364-20.746 c-18.498-5.778-38.641,0.07-51.169,14.829l-11.168,13.146l122.745,104.186l11.153-13.139 C474.242,189.385,476.745,168.562,468.048,151.261z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M445.618,318.641c0.016-52.297-21.256-99.821-55.533-134.083c-28.996-29.01-67.498-48.644-110.357-53.997 v-29.497h-47.454v29.497c-42.85,5.36-81.361,24.986-110.356,53.997C87.625,218.82,66.37,266.344,66.385,318.641 c-0.015,52.312,21.24,99.828,55.533,134.083c4.449,4.457,9.13,8.674,14.011,12.674l-20.437,28.965 c-1.514,2.177-1.066,5.151,1.035,6.773l12.697,9.825c2.086,1.629,5.098,1.305,6.797-0.711l24.685-27.697 c28.022,16.32,60.585,25.72,95.295,25.712c34.718,0.007,67.289-9.392,95.303-25.712l24.678,27.697 c1.714,2.016,4.726,2.34,6.812,0.711l12.698-9.825c2.085-1.622,2.533-4.596,1.019-6.773l-20.437-28.965 c4.881-4,9.562-8.217,14.011-12.674C424.362,418.469,445.634,370.953,445.618,318.641z M409.425,318.641 c0,42.434-17.147,80.674-44.921,108.495c-27.836,27.797-66.068,44.928-108.503,44.936c-42.434-0.008-80.666-17.139-108.487-44.936 c-27.805-27.821-44.936-66.061-44.936-108.495c0-42.427,17.131-80.666,44.936-108.495c27.821-27.782,66.053-44.921,108.487-44.921 c42.434,0,80.667,17.139,108.503,44.921C392.278,237.975,409.425,276.214,409.425,318.641z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "262.559,300.583 198.498,203.017 178.842,214.456 248.069,350.362 349.814,282.95 338.382,263.308  ",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.47d5d1ec9b6fd5e96446605aa9fdc2c5.svg";
export { ForwardRef as ReactComponent };